import moment from 'moment';

/**
 * Extracts {{n}} placeholders from a template string
 * @param {string} text 
 * @returns {number} Count of unique placeholders
 */
export const countPlaceholders = (text) => {
    if (!text) return 0;
    const matches = text.match(/\{\{\d+\}\}/g);
    if (!matches) return 0;
    // Get unique placeholder numbers to avoid double counting
    const unique = new Set(matches);
    return unique.size;
};

/**
 * Formats a date for the backend (Unix timestamp)
 * @param {string|Date} date 
 * @returns {number}
 */
export const formatTimestamp = (date) => {
    return moment(date).unix();
};

/**
 * Transforms UI state into the backend's expected template_variables format
 * @param {Array} placeholders - [{ index: 1, mode: 'static', value: 'Hello', dynamic_key: '' }]
 * @returns {Array} Structured array for the API
 */
export const transformPlaceholders = (placeholders) => {
    return placeholders.map(p => ({
        index: p.index,
        type: 'text',
        mode: p.mode, // 'static' or 'dynamic'
        value: p.mode === 'static' ? p.value : null,
        dynamic_key: p.mode === 'dynamic' ? p.dynamic_key : null
    }));
};

/**
 * Mock data for system variables
 */
export const SYSTEM_VARIABLES = [
    { label: 'Student Name', value: 'student_name' },
    { label: 'Mobile Number', value: 'student_mobile' },
    { label: 'Email Address', value: 'student_email' },
    { label: 'Branch Name', value: 'branch_name' },
    { label: 'Institute Name', value: 'institute_name' },
    { label: 'Current Date', value: 'current_date' }
];

/**
 * Status color mapping for Bootstrap
 */
export const getStatusBadgeClass = (status) => {
    switch (status?.toLowerCase()) {
        case 'created': return 'badge-secondary';
        case 'scheduled': return 'badge-primary';
        case 'in process': return 'badge-info';
        case 'completed': return 'badge-success';
        case 'failed': return 'badge-danger';
        default: return 'badge-light';
    }
};
